// extracted by mini-css-extract-plugin
module.exports = {"optionSelected":"MyShipments_optionSelected__bZAVa","minHeightMobile":"MyShipments_minHeightMobile__g9pNn","loadingOverlay":"MyShipments_loadingOverlay__g6XPl"};